<template lang="pug">
  .recover-password
    .card-login
      div(v-if="submitStatus === 'OK'")
        .mb-2 La contraseña actualizada correctamente
        b-btn(variant="primary" block @click="$router.push({name:'Login'})") Volver al login
      div(v-else-if="submitStatus === 'ERROR'")
        .mb-2 El token no es válido o ya ha caducado
        b-btn(variant="primary" block @click="$router.push({name:'Login'})") Volver al login
      b-form(v-else @submit="onSubmit")
        center
          p
            img(src="../../../public/DA_azul.svg" style="width: 150px")
        h5.text-center Cambiar contraseña
        b-form-group(
          label="Nueva contraseña"
          label-for="password-input"
        )
          b-form-input(
            v-model="form.password"
            id="password-input"
            type="password"
          )
          b-form-invalid-feedback(:state="$v.form.password.required") Este campo es requerido
          b-form-invalid-feedback(:state="$v.form.password.minLength") La contraseña debe contener 6 caracteres o más
        b-form-group(
          label="Repite la contraseña"
          label-for="repeat-password-input"
        )
          b-form-input(
            v-model="form.repeatPassword"
            id="repeat-password-input"
            type="password"
          )
          b-form-invalid-feedback(:state="$v.form.repeatPassword.sameAsPassword") La contraseña no coincide
        center
          b-button.boton(type="submit" variant="secondary" ) Cambiar
</template>

<script>
import { required, sameAs, minLength  } from 'vuelidate/lib/validators'
import { mappActions, mapActions } from 'vuex'

export default {
  props: {
    token: String
  },
  data () {
    return {
      form: {
        password: '',
        repeatPassword: ''
      },
      submitStatus: 'PENDING'
    }
  },
  validations: {
    form: {
      password: {
        required,
        minLength: minLength(6)
      },
      repeatPassword: {
        sameAsPassword: sameAs('password')
      }
    }
  },
  methods: {
    ...mapActions('AuthenticationStore', ['changeUserPassword']),
    onSubmit (event) {
      event.preventDefault()
      if (!this.$v.$invalid) {
        const { password } = this.form
        const token = this.token
        const response = this.changeUserPassword({ password, token})
        if (response) {
          this.submitStatus = 'OK'
        } else {
          this.submitStatus = 'ERROR'
        }
      }
    }
  }
}
</script>
<style lang="scss" scoped>
  .boton{
    margin: 32px;
  }
</style>